import { Component, ViewChild } from "@angular/core";
import {
  Platform,
  IonicPage,
  NavController,
  PopoverController,
  AlertController,
  Slides
} from "ionic-angular";
import { EditorPage } from '../editor/editor';
import { LangPage } from "../lang/lang";
import { TranslateService } from "@ngx-translate/core";

import { StorageProvider } from "../../providers/storage/storage";
import { ModelsProvider } from "../../providers/models/models";
import { LayoutsProvider } from "../../providers/layouts/layouts";
import { SizesProvider } from "../../providers/sizes/sizes";
import { BackgroundsProvider } from "../../providers/backgrounds/backgrounds";

@IonicPage()
@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage {


  @ViewChild('slider') slider: Slides;
  @ViewChild("segments") segments;
  page: any;

  indexToText = ['created','featured','device','clean'];

  screenshots: any = {
    created: [],
    featured: [],
    device: [],
    clean: []
  };
  toDelete:any = null;
  i18n: string[] = [];

  constructor(
    private platform: Platform,
    private popoverCtrl: PopoverController,
    private translate: TranslateService,
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    private modelsProvider: ModelsProvider,
    private layoutsProvider: LayoutsProvider,
    private backgroundsProvider: BackgroundsProvider,
    private sizesProvider: SizesProvider,
    private storageProvider: StorageProvider
  ) {
    this.platform.ready().then(() => {
      this.translate
        .get([
          "PROJECT_CONFIRM_DELETE_SCREENSHOTS_TITLE",
          "PROJECT_CONFIRM_DELETE_PROJECT_TITLE",
          "TITLE_NOT_DEFINED",
          "YES",
          "NO"
        ])
        .subscribe(value => {
          this.i18n = value;
          // console.log("value",value);
        });
    });
  }


  ionViewDidEnter() {
    this.refresh();

  }

  async refresh(){
    this.slideChanged();
    this.screenshots['clean'] =  await this.storageProvider.getMockups('cropped');
    console.log("this.screenshots['clean']",this.screenshots['clean']);
    if( this.screenshots['clean'].length > 0){
      this.screenshots['featured'] = this.storageProvider.getDemo()
      this.screenshots['device'] = this.storageProvider.getDevice();
    }
    this.screenshots['created'] = await this.storageProvider.getScreenshots();
    if(this.screenshots['created'].length == 0)
      this.selectedTab(1);
    console.log('this.screenshots',this.screenshots);
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad ProjectPage');
  }

  toogleMode() {
    if (this.toDelete == null) {
      this.toDelete = [];
    } else {
      this.toDelete = null;
      for (let index in this.screenshots[this.indexToText[this.page]]) {
        this.screenshots[this.indexToText[this.page]][index].deleted = false;
      }
    }
    // else if(this.toDelete.length == 0){
    //   this.toDelete = null;
    // }
  }

  toogleDelete() {
    if (this.toDelete.length == 0) this.presentAlertConfirmDelete("project");
    else {
      this.presentAlertConfirmDelete("screenshots");
    }
  }

  presentAlertConfirmDelete(delete_type) {
    let title = "";
    if (delete_type == "screenshots")
      title = this.i18n["PROJECT_CONFIRM_DELETE_SCREENSHOTS_TITLE"];
    else if (delete_type == "project")
      title = this.i18n["PROJECT_CONFIRM_DELETE_PROJECT_TITLE"];
    else title = this.i18n["TITLE_NOT_DEFINED"];

    let alert = this.alertCtrl.create({
      title: title,
      enableBackdropDismiss: false
    });

    alert.addButton({
      text: this.i18n["YES"],
      handler: (visibility: any) => {
        if (delete_type == "screenshots") this.deleteSelectedScreenshots();
        // else if (delete_type == "project") this.deleteProject();
        else this.toDelete = null;
      }
    });

    alert.addButton({
      text: this.i18n["NO"],
      handler: (visibility: any) => {
        this.toDelete = null;
      }
    });

    alert.present();
  }

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(LangPage);
    popover.present({
      ev: myEvent
    });
  }

  async deleteSelectedScreenshots() {
    let screenshots = this.screenshots[this.indexToText[this.page]];
    console.log("screenshots before", screenshots);
    for (let index in screenshots) {
      console.log("index", index);
      if (this.screenshots[this.indexToText[this.page]][index]["deleted"]){
        screenshots.splice(index, 1);
        return this.deleteSelectedScreenshots();
      }
    }

    console.log("screenshots after", screenshots);
    this.screenshots[this.indexToText[this.page]] = screenshots;

    await this.storageProvider.updateScreenshots(this.screenshots[this.indexToText[this.page]]);
    this.toDelete = null;
  }

  cardAction(i) {
    if (this.toDelete) this.toogleCheckbox(i);
    else this.goToScreenshot(i);
  }
  /**
   * Au clic sur une checkbox pour supprimer un screenshot
   */
  toogleCheckbox(i) {
    let item = this.screenshots[this.indexToText[this.page]][i];
    let found = this.toDelete.findIndex(elem => {
      return elem.id == item.id;
    });

    console.log("getScreenshots stringify", JSON.stringify(this.screenshots[this.indexToText[this.page]][i]));
    if (found !== -1) {
      this.toDelete.splice(found, 1);
      this.screenshots[this.indexToText[this.page]][i]["deleted"] = false;
    } else {
      this.toDelete.push(item);
      this.screenshots[this.indexToText[this.page]][i]["deleted"] = true;
    }

    console.log("this.toDelete", this.toDelete);
  }

  goToScreenshot(index) {
    console.log("goToScreenshot (" + index + ")",  this.screenshots[this.indexToText[this.page]]);
    this.navCtrl.push(EditorPage, this.screenshots[this.indexToText[this.page]][index]);
  }

  newScreenshot() {
    let sizes = this.sizesProvider.getSizes();
    let backgrounds = this.backgroundsProvider.getBackgrounds();

    // let iphone_x = this.modelsProvider.getModel(
    //   'phones',
    //   1
    // );
    let iphone_x_clear = this.modelsProvider.getModel(
      'crop',
      0
    );
    // let layout_left = this.layoutsProvider.getLayout(
    //   "phones",
    //   4
    // );
    let layout_center = this.layoutsProvider.getLayout(
      "phones",
      3
    );
    // let layout_right = this.layoutsProvider.getLayout(
    //   "phones",
    //   5
    // );
    //
    // console.log("iphone_x",iphone_x);
    // console.log("iphone_x_clear",iphone_x_clear);


    // layers: [
    //   {
    //     model:iphone_x,
    //     picture:null,
    //     color:iphone_x.colors[0],
    //     layout:layout_left
    //   },
    //   {
    //     model:iphone_x_clear,
    //     picture:null,
    //     color:iphone_x_clear.colors[0],
    //     layout:layout_right
    //   },

    this.navCtrl.push(EditorPage, {
      layers:[
        {
          model:iphone_x_clear,
          picture:null,
          color:iphone_x_clear.colors[0],
          layout:layout_center
        }
      ],
      texts: [
        {
          value:'',
          fontSize:40,
          fontFamily:"Arial",
          color:"#000000",
          position: {
            horizontal: 0,
            vertical : 0
          },
          rotate: 0
        }
      ],
      size:sizes[0],
      background:{
        color: "#393939",
        color_secondary: "#FFFFFF",
        opacity: 100,
        opacity_secondary: 100,
        type:backgrounds[0]
      }
    });
  }




  // On segment click
  selectedTab(index) {
    this.slider.slideTo(index);
  }


  // On slide changed
  slideChanged() {
    let currentIndex = this.slider.getActiveIndex();
    let slides_count = this.segments.nativeElement.childElementCount;

    this.page = currentIndex.toString();
    if(this.page >= slides_count)
      this.page = (slides_count-1).toString();

    console.log("slides_count",slides_count)
    console.log("this.page",this.page)
    this.centerScroll();
  }

  // Center current scroll
  centerScroll(){
    if(!this.segments || !this.segments.nativeElement)
      return;

    let sizeLeft = this.sizeLeft();
    let sizeCurrent = this.segments.nativeElement.children[this.page].clientWidth;
    let result = sizeLeft - (window.innerWidth / 2) + (sizeCurrent/2) ;

    result = (result > 0) ? result : 0;
    this.smoothScrollTo(result);
  }

  // Get size start to current
  sizeLeft(){
    let size = 0;
    for(let i = 0; i < this.page; i++){
      size+= this.segments.nativeElement.children[i].clientWidth;
    }
    return size;
  }

  // Easing function
  easeInOutQuart(time, from, distance, duration) {
    if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from;
    return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
  }

  // Animate scroll
  smoothScrollTo(endX){
    let startTime = new Date().getTime();
    let startX = this.segments.nativeElement.scrollLeft;
    let distanceX = endX - startX;
    let duration = 400;

    let timer = setInterval(() => {
      var time = new Date().getTime() - startTime;
      var newX = this.easeInOutQuart(time, startX, distanceX, duration);
      if (time >= duration) {
        clearInterval(timer);
      }
      this.segments.nativeElement.scrollLeft = newX;
    }, 1000 / 60); // 60 fps
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts